<template>
  <layout-guest>
    <v-form @submit.prevent v-model="formulario" autocomplete="off">
      <main class="container-wrap-base">
        <div
          class="rectangle"
          :style="`background-image: linear-gradient(to bottom, ${entityConfig.backgroundGradienColorFrom}, ${entityConfig.backgroundGradienColorTo});`"
        >
          <div class="row">
            <div class="col-sm">
              <div class="group-5">
                <div class="row">
                  <v-col cols="12" sm="12" md="12" style="padding-top: 10%">
                    <p class="source-sans-pro-ligh">
                      {{ $t("login.blockingContraseña") }}
                    </p>
                  </v-col>
                </div>

                <div class="row">
                  <v-col sm="12" md="12" lg="12">
                    <label class="label-login"> {{ $t("login.Contraseña") }}</label>

                    <v-text-field
                      :rules="[
                        rules.required,
                        rules.maxPass,
                        rules.minPass,
                        rules.ValidatorUppercase,
                        rules.ValidatorLowercase,
                        rules.ValidatorHasNumber,
                        rules.ValidatorNotComillas,
                        rules.validatorSymbos,
                        rules.validatorSymbolPermitidos,
                        rules.validatorConsecutivos,
                        rules.referenceValidatorHasalias,
                      ]"
                      counter
                      maxlength="30"
                      hint="Mínimo 6 caracteres, Maximo 30 caracteres,"
                      :color="entityConfig.primaryColor"
                      dense
                      autocomplete="false"
                      outlined
                      :type="show1 ? 'text' : 'password'"
                      :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="show1 = !show1"
                      v-model="form.newPassword"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <label class="label-login">{{
                      $t("supplierData.repetirContraseña")
                    }}</label>
                    <v-text-field
                      placeholder="Confirme su contraseña"
                      v-model="confirmPassword"
                      :color="entityConfig.primaryColor"
                      dense
                      outlined
                      :rules="passwordRules.concat(passwordConfirmationRule)"
                      require
                      hint="12 a 30 caracteres"
                      max="30"
                      autocomplete="false"
                      :type="show2 ? 'text' : 'password'"
                      :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="show2 = !show2"
                    ></v-text-field>
                  </v-col>
                </div>

                <div class="row">
                  <v-col cols="12" sm="12" md="12" style="padding-bottom: 10%">
                    <v-btn
                      :style="`color: ${entityConfig.secondaryColor}`"
                      @click="blockingPasswordPost"
                      depressed
                      :color="entityConfig.primaryColor"
                      :disabled="!formIsValid"
                      class="float-end m-2 v-btn-width-default rectangle-button"
                    >
                      {{ $t("login.aceptar") }}
                    </v-btn>
                  </v-col>
                </div>
              </div>
            </div>
          </div>
        </div>
        <overlay :visible="spinner" :opacity="0.8"></overlay>
        <confirm-dialog
          :visible="confirmDialog"
          @closed="confirmDialog = !confirmDialog"
        ></confirm-dialog>
        <overlay :visible="spinner" :opacity="1"></overlay>
      </main>
    </v-form>
  </layout-guest>
</template>

<style scoped lang="scss">
@import "./login.style";
</style>

<script>
import passwordValidator from "password-validator";

import LayoutGuest from "../../components/layouts/layout-guest.vue";
import Api from "../../Services/index";
import Overlay from "../../components/layouts/overlay.vue";

export default {
  name: "App",
  data() {
    return {
      isError: false,
      entityConfig: {},

      spinner: true,
      passwordRules: [(v) => !!v || "La contraseña es requerida"],
      confirmPasswordRules: [(v) => !!v || "La confirmacion es requerida"],
      formulario: false,
      show1: false,
      show2: false,
      form: {
        newPassword: "",
        token: "",
      },
      confirmPassword: "",
      confirmDialog: false,
      rules: {
        referenceValidatorHasalias: (v) => {
          if (this.form.alias) {
            let alias = this.form.alias.toLowerCase().trim();
            return (
              !v.toLowerCase().includes(alias) ||
              "El contraseña no debe incluir el alias"
            );
          }
          return true;
        },

        referenceValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(1);
          return schema.validate(v) || "Debe ser numérico";
        },

        validatorConsecutivos: (v) =>
          !/(.)\1{2}/.test(v) ||
          "No se permiten mas de 2 caracteres consecutivos",

        validatorSymbolPermitidos: (v) =>
          !/[^\w<>+|&!*%?:. =-]/.test(v) ||
          "Caracteres especiales permitidos: <>+|&!*%?:. =-",

        validatorSymbos: (v) => {
          let schema = new passwordValidator();
          schema.has().symbols();
          return (
            schema.validate(v) ||
            "Debe contener caracteres especiales: <>+|&!*%?:. =-"
          );
        },

        ValidatorUppercase: (v) => {
          var schema = new passwordValidator();
          schema.has().uppercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en mayuscula"
          );
        },

        ValidatorLowercase: (v) => {
          var schema = new passwordValidator();
          schema.has().lowercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en minuscula"
          );
        },

        ValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(2);
          return (
            schema.validate(v) || "Debe contener al menos 2 carateres numericos"
          );
        },

        ValidatorNotComillas: (v) => {
          let regex = /["']+/;
          var schema = new passwordValidator();
          schema.has().not(regex);
          return (
            schema.validate(v) ||
            "Las comillas no son tomadas como caracteres validos"
          );
        },

        maxPass: (v) => v.length <= 30 || "30 caracteres Maximo",

        minPass: (v) => v.length >= 12 || "12 caracteres Minimo",

        required: (value) => !!value || "Este campo es requerido..",
      },
    };
  },
  components: {
    Overlay,
    "layout-guest": LayoutGuest,
  },
  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
    }, 1000);
    let codNrbeEn = sessionStorage.getItem('codNrbeEn');
    let userId = this.$route.query.id;
    let token = this.$route.query.token;

    if (codNrbeEn) {
      this.urlLogin = `/?codNrbeEn=${codNrbeEn}`;
    } else {
      this.isError = true;
      this.spinner = false;
      return;
    }

    if (userId && token) {
      this.sendConfirmation(userId, token);
    } else {
      this.spinner = false;
    }
  },

  computed: {
    passwordConfirmationRule() {
      return () =>
        this.form.newPassword === this.confirmPassword ||
        "Las contraseñas no coincide";
    },

    confirmPasswordIsValid() {
      return !!this.confirmPassword;
    },

    confirmPasswordIgualIsValid() {
      return this.form.newPassword === this.form.confirmPassword;
    },

    formIsValid() {
      return this.formulario;
    },
  },

  methods: {
    blockingPasswordPost() {
      this.form.token = this.$route.query.token;
      this.spinner = true;

      Api.patch("/usuarios/credenciales", this.form)
        .then(() => {
          this.confirmDialog = true;
          this.$toast.success("Se recupero su usuario de forma exitosa");
          this.$router.push({ path: "home" });
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
  },
};
</script>
